import { memo } from 'react';
import { Card } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import PropTypes from 'prop-types';
import { NO_DATA } from '../../constants/message.constants';

const ScheduledActivityWithDataTable = ({
  isLoading,
  projectsData,
  totalRows,
  perPage,
  handlePageChange,
  handlePerRowsChange,
}) => {
  const tableColumns = [
    {
      name: <div>TEAM MEMBER</div>,
      selector: (row) => row.memberName,
      sortable: true,
      cell: (row) => row.memberName,
      filterable: true,
      width: '160px',
    },
    {
      name: <div>EMAIL</div>,
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => row.email,
      filterable: true,
      width: '275px',
    },
    {
      name: <div>EMPLOYEE ID</div>,
      selector: (row) => row.employeeId,
      sortable: true,
      cell: (row) => row.employeeId,
      filterable: true,
      width: '125px',
    },
    {
      name: <div>SITE NAME</div>,
      selector: (row) => row.siteName,
      sortable: true,
      cell: (row) => row.siteName,
      width: '140px',
    },
    {
      name: <div>PROJECT NAME</div>,
      selector: (row) => row.projectName,
      sortable: true,
      cell: (row) => row.projectName,
    },
    {
      name: <div>SHIFT TIME</div>,
      selector: (row) => row.shiftTime,
      sortable: false,
      cell: (row) => row.shiftTime,
      width: '195px',
    },
    {
      name: <div>CHECK-IN TIME</div>,
      selector: (row) => row.checkInTime,
      sortable: false,
      cell: (row) => row.checkInTime,
      width: '155px',
    },
    {
      name: <div>CHECK-OUT TIME</div>,
      selector: (row) => row.checkOutTime,
      sortable: false,
      cell: (row) => row.checkOutTime,
      width: '155px',
    },
    {
      name: <div>STATUS</div>,
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => row.status,
      width: '100px',
    },
    {
      name: <div>SCHEDULE TYPE</div>,
      selector: (row) => row.scheduleType,
      sortable: true,
      cell: (row) => row.scheduleType,
      width: '100px',
    },
    {
      name: <div>PRODUCTIVE TIME</div>,
      selector: (row) => row.productiveTime,
      sortable: false,
      cell: (row) => row.productiveTime,
      width: '200px',
    },
    {
      name: <div>NON-PRODUCTIVE TIME</div>,
      selector: (row) => row.nonProductiveTime,
      sortable: false,
      cell: (row) => row.nonProductiveTime,
      width: '200px',
    },
    {
      name: <div>WORK SESSION TIME</div>,
      selector: (row) => row.worksessionHours,
      sortable: false,
      cell: (row) => row.worksessionHours,
    },
    {
      name: <div>IDLE TIME</div>,
      selector: (row) => row.idleTime,
      sortable: false,
      cell: (row) => row.idleTime,
    },
    {
      name: <div>SHIFT TOTAL HOURS</div>,
      selector: (row) => row.expectedHours,
      sortable: false,
      cell: (row) => row.expectedHours,
      width: '83px',
    },
    {
      name: (
        <div>
          SCHEDULE CONFORMANCE
          <br />
          <span style={{ fontSize: '10px' }}>
            (Total time / Scheduled Time)
          </span>
        </div>
      ),
      selector: (row) => row.workPercent,
      sortable: false,
      cell: (row) => row.workPercent,
      width: '120px',
    },
  ];

  return (
    <Card.Body className="p-0">
      <div>
        <DataTable
          columns={tableColumns}
          data={projectsData}
          noDataComponent={
            isLoading ? (
              ''
            ) : (
              <p className="text-center pt-3">{NO_DATA.SCHEDULED_ACTIVITY}</p>
            )
          }
          highlightOnHover
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={perPage}
          paginationRowsPerPageOptions={[10, 20, 30]}
          paginationComponentOptions={{
            rowsPerPageText: 'Show Results',
            rangeSeparatorText: 'out of',
          }}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
        />
      </div>
    </Card.Body>
  );
};

ScheduledActivityWithDataTable.propTypes = {
  isLoading: PropTypes.bool,
  projectsData: PropTypes.array,
  totalRows: PropTypes.number,
  perPage: PropTypes.number,
  handlePageChange: PropTypes.func,
  handlePerRowsChange: PropTypes.func,
};

export default memo(ScheduledActivityWithDataTable);
